import { render, staticRenderFns } from "./viewAcceptanceOrder.vue?vue&type=template&id=8452b590&scoped=true"
import script from "./viewAcceptanceOrder.vue?vue&type=script&lang=js"
export * from "./viewAcceptanceOrder.vue?vue&type=script&lang=js"
import style0 from "./viewAcceptanceOrder.vue?vue&type=style&index=0&id=8452b590&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8452b590",
  null
  
)

export default component.exports